import { isClient, isServer } from '@/legacy/components/base/utils';

export const nullProfileReplace = (url?: string | null) => {
	if (url == null) return '/img/Profile.png';
	return url;
};

export const nullReplace = (url?: string | null) => {
	if (url == null) return '/img/PackageBackground.png';
	return url;
};

export const nullCashReplace = (url?: string | null) => {
	if (url == null || url == '') return '/img/cash.png';
	return url;
};

export const nullCasualReplace = (url?: string | null) => {
	if (url == null) return '/img/casual.png';
	return url;
};
export const nullBannerReplace = (url?: string | null) => {
	if (url == null) return '/img/Banner.png';
	return url;
};

/** 에러 고유 식별 */
export const PromiseNull = Symbol('PromiseNull');

/** 값이 비지 않았음을 체크 */
export function promiseNotNullCheck<T>(data: T | typeof PromiseNull | undefined): data is T {
	return data !== PromiseNull && data != null;
}

/** 서버 전용 */
export const SERVER_PUBLIC_URL = isServer ? 'http://localhost:' + process.env.PORT : '';
/** 클라 전용 */
export const CLIENT_PUBLIC_URL = isClient ? window.location.origin : '';

/** 겸용
 *  주의: 서버가 클라의 도메인 주소를 알아야할 때는 적용되지 않음
 */
export const PUBLIC_URL = CLIENT_PUBLIC_URL !== '' ? CLIENT_PUBLIC_URL : SERVER_PUBLIC_URL;
